import { Box, Stack, Typography } from '@mui/material';

import { colors } from 'src/global/styles/colors';

import { HomepagePreview } from './HomepagePreview';
import { ReferralPagePreview } from './ReferralPagePreview';

export function ThemePreview() {
  return (
    <Stack gap={3}>
      <Typography fontSize={'14px'} color={'white'}>
        Customize the look and feel of your page by adjusting colors, fonts, and images. This ensures your sale page
        aligns with your project's branding.
      </Typography>
      <Stack
        direction={'row'}
        justifyContent={'space-between'}
        gap={2}
        width={'100%'}
        padding={'24px 14px'}
        borderRadius={'8px'}>
        <HomepagePreview />
        <Box width={'1px'} bgcolor={colors.neutral06} />
        <ReferralPagePreview />
      </Stack>
    </Stack>
  );
}
